import React, { useState, useRef } from 'react';
import Inbox from './Inbox';
import './EmailDrawer.css';

interface EmailDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onClaimUpdate?: (claimId: string) => void;
  defaultTab?: string;
}

const EmailDrawer: React.FC<EmailDrawerProps> = ({ isOpen, onClose, onClaimUpdate, defaultTab }) => {
  const [refreshing, setRefreshing] = useState(false);
  const inboxRef = useRef<any>(null);
  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div 
          className="email-drawer-backdrop" 
          onClick={onClose}
        />
      )}
      
      {/* Drawer */}
      <div className={`email-drawer ${isOpen ? 'open' : ''}`}>
        <div className="email-drawer-header">
          <h2>Email Inbox</h2>
          <div className="header-buttons">
            <button 
              className="refresh-drawer-button"
              onClick={() => inboxRef.current?.handleRefresh()}
              disabled={refreshing}
              title="Refresh emails"
            >
              <span className={refreshing ? 'rotating' : ''}>⟳</span>
            </button>
            <button 
              className="email-drawer-close"
              onClick={onClose}
              aria-label="Close email drawer"
            >
              ×
            </button>
          </div>
        </div>
        
        <div className="email-drawer-content">
          <Inbox 
            ref={inboxRef}
            onClaimUpdate={onClaimUpdate} 
            onRefreshingChange={setRefreshing}
            defaultTab={defaultTab}
          />
        </div>
      </div>
    </>
  );
};

export default EmailDrawer;